
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import LandingPage from './components/LandingPage';
import SignUp from './components/SignUp';
import SignIn from './components/SignIn';
import AppShell from './components/AppShell';
import BookmarksPage from './components/BookmarksPage';
import FinishedPage from './components/FinishedPage';
import TBRPage from './components/TBRPage';
import ProtectedRoute from './components/ProtectedRoute';
import PublicRoute from './components/PublicRoute';
import ProfilePictureUpload from './components/ProfilePictureUpload';
import EpubPage from './components/EpubPage';
import ReaderPage from './components/ReaderPage';

import './App.css';

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<PublicRoute><LandingPage /></PublicRoute>} />
        <Route path="/signup" element={<PublicRoute><SignUp /></PublicRoute>} />
        <Route path="/signin" element={<PublicRoute><SignIn /></PublicRoute>} />
        <Route path="/profile-picture" element={<PublicRoute><ProfilePictureUpload /></PublicRoute>} />
        <Route element={<ProtectedRoute><AppShell /></ProtectedRoute>}>
          <Route path="/dashboard" />
          <Route path="/library" />
          <Route path="/notifications" />
          <Route path="/profile" />
          <Route path="/profile/general-rules" />
        </Route>
        <Route path="/bookmarks" element={<ProtectedRoute><BookmarksPage /></ProtectedRoute>} />
        <Route path="/finished" element={<ProtectedRoute><FinishedPage /></ProtectedRoute>} />
        <Route path="/tbr" element={<ProtectedRoute><TBRPage /></ProtectedRoute>} />
        <Route path="/epub/:id" element={<ProtectedRoute><EpubPage /></ProtectedRoute>} />
        <Route path="/epub/:id/read" element={<ProtectedRoute><ReaderPage /></ProtectedRoute>} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
